import { waitForElements, headerTransition$, updateBodyPaddingTop, getElementOrParentByClassName } from '../helpers/utils';
import { renderWishlistCounter } from '../services/wishlist.service';
import { isIOS } from '../vue/constants/devices';
import Scroll from './Scroll';
import { Carousel } from './Carousel';
import IsMobile from './IsMobile';
import { whenOverlayShown$ } from './Overlay';
import { SEARCH_CLOSE } from '../constants/events.constants';
export default (($) => {
    console.log('UNTUCKit : Module : Nav : loaded');
    let navOpen = false;
    const $window = $(window);
    const $wrapAll = $('html,body');
    function close() {
        if (navOpen) {
            $('.js-nav').removeClass('is-active');
            $wrapAll.removeClass('nav-opened');
            $(".m-menu__checkbox").prop("checked", false);
            Scroll.unlock();
            navOpen = false;
        }
    }
    function open() {
        if (!navOpen) {
            $('.js-nav').addClass('is-active');
            $wrapAll.addClass('nav-opened');
            Scroll.lock();
            navOpen = true;
        }
    }
    const bindUIActions = function () {
        console.log('bindUIActions');
        $('.js-nav').on('touchmove', function (e) {
            e.stopPropagation();
        });
        $('.js-nav').on('click', function () {
            if (!IsMobile.check())
                close();
        });
        $window.on('resize', function () {
            // if it's a iOS device, reset the nav height
            if (isIOS()) {
                setIOSNavHeight();
            }
        });
        $('.js-show-nav').off('click').on('click', function () {
            toggle();
            return false;
        });
        document.addEventListener('click', function (e) {
            const target = e.target;
            if (getElementOrParentByClassName(target, 'js-hide-nav')) {
                close();
            }
        });
        // desktop and mobile carousels are rendered at different times
        waitForElements(".mobile-nav .js-utk-carousel").then((els) => handleCarousels(els, "mobile")).catch(() => { });
        waitForElements(".header__bottom-bar .js-utk-carousel").then((els) => handleCarousels(els, "desktop")).catch(() => { });
        const bottomBar = document.querySelector(".header__bottom-bar");
        headerTransition$.subscribe({
            next: (smallerHeader) => {
                if (smallerHeader) {
                    if (bottomBar) {
                        const bottomBarHeight = bottomBar.offsetHeight;
                        updateBodyPaddingTop(bottomBarHeight);
                        bottomBar.classList.add("header__bottom-bar--hidden");
                    }
                }
                else {
                    if (bottomBar) {
                        bottomBar.classList.remove("header__bottom-bar--hidden");
                    }
                }
            },
            complete: () => {
                if (bottomBar) {
                    bottomBar.classList.remove("header__bottom-bar--hidden");
                }
            }
        });
        whenOverlayShown$.subscribe(() => close());
        document.addEventListener('click', (e) => {
            const target = e.target;
            // close mobile nav when chat link is clicked
            if (getElementOrParentByClassName(target, 'open_chat') && target.closest('.mobile-nav')) {
                e.preventDefault();
                close();
            }
        });
    };
    // if the user is on an iOS device, then we can't use vh to get nav height
    // since it will count the address bar as part of that "vh" value
    const fixIOSNavHeight = () => {
        if (isIOS()) {
            // add a style element to track the nav height
            const newStyleEl = document.createElement('style');
            newStyleEl.setAttribute('id', 'js-ios-nav-styles');
            document.body.appendChild(newStyleEl);
            // set our initial nav height
            setIOSNavHeight();
        }
    };
    const setIOSNavHeight = () => {
        const navStyleEl = document.querySelector('#js-ios-nav-styles');
        if (navStyleEl) {
            const actualDeviceHeight = window.innerHeight;
            const navCompensation = '128px';
            navStyleEl.innerHTML = `.is-active > .submenu-wrap-top {
        height: calc(${actualDeviceHeight}px - ${navCompensation})
      };`;
        }
    };
    const previewMobilenav = (slug = null, draft = false) => {
        const mpath = "/?view=menu&mobile=1&preview=1" + (slug ? "&slug=" + slug : "") + "&draft=" + draft;
        $.get(mpath, function (data) {
            console.log('UNTUCKit : Module : Meganav : get Meganav mobile preview');
            const mobileNav = $('<output>').append($.parseHTML(data));
            $('.mobile-nav').html(mobileNav.find('.mobile-nav').html());
            bindUIActions();
        });
    };
    function toggle() {
        if ($('.nav-opened').length) {
            close();
        }
        else {
            open();
        }
    }
    function init() {
        console.log('UNTUCKit : Module : Nav : init');
        bindUIActions();
        fixIOSNavHeight();
        renderWishlistCounter();
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('slug') && urlParams.has('navpreview')) {
            const slug = urlParams.get('slug');
            const draft = urlParams.get('draft');
            previewMobilenav(slug, draft);
        }
    }
    return { init };
})($);
function handleCarousels(els, device) {
    Array.from(els).forEach((el) => {
        new Carousel(el, { rotation: el.dataset.rotation }, device).setup();
    });
}
document.addEventListener("click", handleMobileMenuBackClick);
document.addEventListener("click", (e) => {
    const target = e.target;
    const searchButton = getElementOrParentByClassName(target, "header-actions__search-button");
    if (searchButton) {
        const parent = searchButton.parentElement;
        const searchFormContainer = parent.querySelector(".header-actions__search-form-container");
        if (searchFormContainer) {
            if (searchFormContainer.classList.contains('hidden')) {
                searchFormContainer.classList.remove('hidden');
                const searchForm = parent.querySelector('search-form');
                if (searchForm) {
                    searchForm.setFocus();
                }
            }
            else {
                document.dispatchEvent(new CustomEvent(SEARCH_CLOSE));
            }
        }
    }
});
document.addEventListener(SEARCH_CLOSE, () => {
    const searchFormContainer = document.querySelector(".header-actions__search-form-container");
    if (searchFormContainer) {
        searchFormContainer.classList.add("hidden");
    }
    const searchButton = document.querySelector(".header-actions__search-button");
    if (searchButton) {
        searchButton.focus();
    }
});
function handleMobileMenuBackClick(e) {
    const menuToggleEl = getElementOrParentByClassName(e.target, 'm-menu__toggle');
    if (menuToggleEl) {
        const inputId = menuToggleEl.dataset.inputId;
        if (inputId) {
            const inputEl = document.getElementById(inputId);
            if (inputEl) {
                inputEl.checked = false;
            }
        }
    }
}
